<mat-expansion-panel [expanded]="!this.section">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ section.label | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form
    class="form-container"
    *ngIf="form"
    [formGroup]="form"
    fxLayout="row wrap"
    fxLayoutAlign="start none"
    fxLayoutGap="20px grid"
  >
    <mmx-question
      *ngFor="let question of questions"
      [fxFlex]="question.flex"
      [fxFlex.xs]="100"
      [question]="question"
      [form]="form"
      [parent]="self"
      [disabled]="section.isDisabled"
      [fileSource]="fileSource"
    ></mmx-question>
    <div
      *ngIf="showSaveButton"
      class="full-width"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div fxFlex></div>
      <div *ngIf="section.isDisabled" fxFlex class="text-right pr-5 text-warn">
        {{ 'patient-intake.custom-section.disabled' | translate }}
      </div>
      <mmx-progress-button
        [disabled]="section.isDisabled"
        (btnClick)="submit()"
        [options]="btnOpts"
      ></mmx-progress-button>
    </div>
  </form>
</mat-expansion-panel>
